<template>
  <div>
    <main-layout />
  </div>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";

export default {
  name: "App",
  components: {
    MainLayout,
  },

  data: () => ({}),
};
</script>
